'use client';

import React from 'react';

import { BlockBatchSkeleton } from './BlockBatchSkeleton';
import {
  CMS_PAGE_LOADING_PLACEHOLDER_BLOCKS,
  CMS_PAGE_LOADING_TEST_IDS,
  RENDERED_PAGE_CLASS,
} from './BlockBatchSkeleton.consts';

export const CmsPageLoading = (): React.ReactElement => {
  return (
    <div className={RENDERED_PAGE_CLASS} data-testid={CMS_PAGE_LOADING_TEST_IDS.root}>
      <BlockBatchSkeleton
        blocks={CMS_PAGE_LOADING_PLACEHOLDER_BLOCKS}
        firstBlockIndex={0}
      />
    </div>
  );
};
